import React from "react";
import Frame from "../../components/frame";
import { useParams } from "react-router-dom";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: this.props?.status != "undefined" ? this.props?.status : "",
    }
  }

  render() {  

    return (
      <Frame withHeader={false} withFooter={true}>
        <div className="main">
          <header id="header">
            <nav
              data-aos="zoom-out"
              data-aos-delay="800"
              className="navbar gameon-navbar navbar-expand"
            >
              <div className="container header">
                <a className="navbar-brand" href="https://caesiumlab.com">
                  <img src="assets/image/logo.png" alt="" />
                </a>
                <ul className="navbar-nav action">
                  <li className="nav-item ml-2">
                    {this.props.isConnected ? (
                      <button
                        type="button"
                        disabled={this.state.loading}
                        onClick={() => this.props.open()}
                        className="btn ml-lg-auto btn-bordered-white"
                      >
                        <i className="icon-wallet mr-md-2"></i> Wallet
                        Disconnect
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn button_animation ml-lg-auto btn-bordered-white"
                        disabled={this.state.loading}
                        onClick={() => this.props.open()}
                      >
                        <i className="icon-wallet mr-md-2"></i>Wallet Connect
                      </button>
                    )}

                    {/* {this.state.is_connected ? (
                      <button type="button" disabled={this.state.loading} onClick={()=>this.disconnectFromWallet()} className="btn ml-lg-auto btn-bordered-white">
                        <i className="icon-wallet mr-md-2"></i> Wallet Disconnect
                      </button>
                    ):(
                      <button type="button" className="btn button_animation ml-lg-auto btn-bordered-white" disabled={this.state.loading} onClick={()=>this.connectToWallet()}>
                        <i className="icon-wallet mr-md-2"></i>Wallet Connect
                      </button>
                    )} */}
                    {/* <a href="#" className="btn ml-lg-auto btn-bordered-white"><i className="icon-wallet mr-md-2"></i>Wallet Connect</a> */}
                  </li>
                  <li className="nav-item ml-2">
                    <a
                      target="_blank"
                      className="btn ml-lg-auto telegram_btn btn-bordered-white"
                      href="https://t.me/caesiumlabmedia"
                    >
                      <img src="assets/image/telegram.png" />
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          </header>
          <script>    
            var success_response = 'success';
            window.ReactNativeWebView.postMessage(success_response);
            </script>
          </div>
  
      </Frame>
    );
  }
}

function HomeHOC(props) {
  let { status } = useParams();

  return (
    <Home
      status={status}
      {...props}
    />
  );
}

export default HomeHOC;
